import {request, serviceUrl} from "@/utils/request";

//获取告警联动实时视频列表
export function getAlarmLinkageVideoList(recordId){
    return request({
        url: serviceUrl.deviceService + "/alarm/linkage/video/list",
        params: {
            recordId
        }
    })
}


//获取告警联动历史视频列表
export function getAlarmLinkageHistorVideoList(recordId){
  return request({
    url: serviceUrl.deviceService + "/alarm/linkage/video/list-history",
    params: {
      recordId
    }
  })
}


//剪切新的告警联动视频
export function disConnectByRecordIdAndDeviceId(recordId,deviceId){
    return request({
        url: serviceUrl.deviceService + "/alarm/linkage/video/disConnectByRecordIdAndDeviceId",
        params: {
            recordId,deviceId
        }
    })
}
